import {
  USER_LIST_START,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  USER_INVITE_START,
  USER_INVITE_SUCCESS,
  USER_INVITE_FAIL,
  USER_BY_ID_START,
  USER_BY_ID_SUCCESS,
  USER_BY_ID_FAIL,
  DEACTIVATE_USER_START,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAIL,
  ACTIVATE_USER_START,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAIL,
  USER_UPDATE_START,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL,
  UPLOAD_USER_LOGO_START,
  UPLOAD_USER_LOGO_SUCCESS,
  UPLOAD_USER_LOGO_FAIL,
  USER_LOGIN_START,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_CONFIRM_REST_PASS_START,
  USER_CONFIRM_REST_PASS_SUCCESS,
  USER_CONFIRM_REST_PASS_FAIL,
  USER_CONFIRM_REGISTRATION_START,
  USER_CONFIRM_REGISTRATION_SUCCESS,
  USER_CONFIRM_REGISTRATION_FAIL,
  REPEAT_USER_INVITE_START,
  REPEAT_USER_INVITE_SUCCESS,
  REPEAT_USER_INVITE_FAIL,
} from './constants';
import {
  requestGetUsers,
  requestInviteUser,
  requestGetUserById,
  requestDeactivateUser,
  requestActivateUser,
  requestUpdateUser,
  requestUploadPhotoUser,
  requestRepeatInviteUser,
  requestUpdateUserRole,
  requestGetProfile, requestUpdateProfile
} from '../../api/user';
import { logIn, ConfirmResetPassword, ConfirmRegistration } from '../../api/auth';
import { serviceLocalStorage } from '../../utils/serviceLocalStorage';
import { ROUTES } from '../../constants/routes';

export const userListStart = () => ({ type: USER_LIST_START });
export const userListSuccess = (data) => ({ type: USER_LIST_SUCCESS, payload: data });
export const userListFail = (message) => ({ type: USER_LIST_FAIL, payload: message });

export const inviteUserStart = () => ({ type: USER_INVITE_START });
export const inviteUserSuccess = (payload) => ({ type: USER_INVITE_SUCCESS, payload });
export const inviteUserFail = (message) => ({ type: USER_INVITE_FAIL, payload: message });

export const repeatInviteUserStart = () => ({ type: REPEAT_USER_INVITE_START });
export const repeatInviteUserSuccess = (payload) => ({ type: REPEAT_USER_INVITE_SUCCESS, payload });
export const repeatInviteUserFail = (message) => ({
  type: REPEAT_USER_INVITE_FAIL,
  payload: message
});

export const getUserByIdStart = () => ({ type: USER_BY_ID_START });
export const getUserByIdSuccess = (data) => ({ type: USER_BY_ID_SUCCESS, payload: data });
export const getUserByIdFail = (message) => ({ type: USER_BY_ID_FAIL, payload: message });

export const deactivateUserStart = () => ({ type: DEACTIVATE_USER_START });
export const deactivateUserSuccess = (id) => ({ type: DEACTIVATE_USER_SUCCESS, id });
export const deactivateUserFail = (message) => ({ type: DEACTIVATE_USER_FAIL, payload: message });

export const activateUserStart = () => ({ type: ACTIVATE_USER_START });
export const activateUserSuccess = (id) => ({
  type: ACTIVATE_USER_SUCCESS,
  id
});
export const activateUserFail = (message) => ({ type: ACTIVATE_USER_FAIL, payload: message });

export const updateUserStart = () => ({ type: USER_UPDATE_START });
export const updateUserSuccess = (data) => ({ type: USER_UPDATE_SUCCESS, payload: data });
export const updateUserFail = (message) => ({ type: USER_UPDATE_FAIL, payload: message });

export const uploadUserLogoStart = () => ({ type: UPLOAD_USER_LOGO_START });
export const uploadUserLogoSuccess = (data) => ({ type: UPLOAD_USER_LOGO_SUCCESS, payload: data });
export const uploadUserLogoFail = (message) => ({ type: UPLOAD_USER_LOGO_FAIL, payload: message });

export const userLogInStart = () => ({ type: USER_LOGIN_START });
export const userLogInSuccess = (data) => ({ type: USER_LOGIN_SUCCESS, payload: data });
export const userLogInFail = (message) => ({ type: USER_LOGIN_FAIL, payload: message });

export const userConfirmResetPasswordStart = () => ({ type: USER_CONFIRM_REST_PASS_START });
export const userConfirmResetPasswordSuccess = (data) => ({
  type: USER_CONFIRM_REST_PASS_SUCCESS,
  payload: data
});
export const userConfirmResetPasswordFail = (message) => ({
  type: USER_CONFIRM_REST_PASS_FAIL,
  payload: message
});

export const userConfirmRegistrationStart = () => ({ type: USER_CONFIRM_REGISTRATION_START });
export const userConfirmRegistrationSuccess = (data) => ({
  type: USER_CONFIRM_REGISTRATION_SUCCESS,
  payload: data
});
export const userConfirmRegistrationFail = (message) => ({
  type: USER_CONFIRM_REGISTRATION_FAIL,
  payload: message
});

const getErrorDetails = (error) => {
  return error.detail || error.response?.data?.detail || error.toString();
};

export const getListUsers = (filter) => async (dispatch) => {
  try {
    dispatch(userListStart());
    const data = await requestGetUsers(filter);
    dispatch(userListSuccess(data));
  } catch (error) {
    dispatch(userListFail(error.detail));
  }
};

export const inviteUser = (data) => async (dispatch) => {
  try {
    dispatch(inviteUserStart());

    const res = await requestInviteUser(data);

    dispatch(inviteUserSuccess(res));
  } catch (error) {
    dispatch(inviteUserFail(error.response.data));
  }
};

export const repeatInviteUser = (id, openAlert) => async (dispatch) => {
  try {
    dispatch(repeatInviteUserStart());

    const res = await requestRepeatInviteUser(id);

    dispatch(repeatInviteUserSuccess(res));
    openAlert();
  } catch (error) {
    dispatch(repeatInviteUserFail(error.response.data));
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
    dispatch(getUserByIdStart());

    const data = await requestGetUserById(id);
    dispatch(getUserByIdSuccess(data));
  } catch (error) {
    dispatch(getUserByIdFail(error.detail));
  }
};

export const deactivateUser = (id) => async (dispatch) => {
  try {
    dispatch(deactivateUserStart());
    await requestDeactivateUser(id);
    dispatch(deactivateUserSuccess(id));
  } catch (error) {
    dispatch(deactivateUserFail(error.detail));
  }
};

export const activateUser = (id) => async (dispatch) => {
  try {
    dispatch(activateUserStart());
    await requestActivateUser(id);
    dispatch(activateUserSuccess(id));
  } catch (error) {
    dispatch(activateUserFail(error.detail));
  }
};

export const updateUser = (id, userData, userRole, isProfile = false) => async (dispatch) => {
  try {
    dispatch(updateUserStart());
    if (isProfile) {
      if (userData) await requestUpdateProfile(userData);
      if (userRole) await requestUpdateUserRole(id, userRole);
    } else {
      if (userData) await requestUpdateUser(id, userData);
      if (userRole) await requestUpdateUserRole(id, userRole);
      if (userRole || userData) await dispatch(getUserById(id));
    }
    dispatch(updateUserSuccess({}));
  } catch (error) {
    dispatch(updateUserFail(error.detail));
  }
};

export const uploadUserLogo = (id, logo) => async (dispatch) => {
  try {
    dispatch(uploadUserLogoStart());
    const data = await requestUploadPhotoUser(id, logo);
    dispatch(uploadUserLogoSuccess(data));
  } catch (error) {
    dispatch(uploadUserLogoFail(error.detail));
  }
};

export const userLogIn = (formData, setShowError, resetForm) => async (dispatch) => {
  try {
    dispatch(userLogInStart());

    await logIn(formData).then((res) => {
      serviceLocalStorage.setLocalStorage(res);
      setShowError(false);
      resetForm();
      dispatch(userLogInSuccess());
    });
  } catch (error) {
    dispatch(userLogInFail(error.detail));
    setShowError(true);
  }
};

export const getCurrentUser = (callback) => async (dispatch) => {
  try {
    dispatch(userLogInStart());
    const data = await requestGetProfile();
    dispatch(userLogInSuccess(data));
    callback && callback(data);
  } catch (error) {
    dispatch(userLogInFail(error.detail));
  }
};

export const getCurrentProfile = (callback) => async () => {
  const data = await requestGetProfile();
  callback && callback(data);
}

export const userConfirmResetPassword = (formData, resetForm) => async (dispatch) => {
  try {
    dispatch(userConfirmResetPasswordStart());
    await ConfirmResetPassword(formData).then((res) => {
      dispatch(userConfirmResetPasswordSuccess(res));
      resetForm();
      document.location.href = ROUTES.LOGIN;
    });
  } catch (error) {
    dispatch(userConfirmResetPasswordFail(error.detail));
  }
};

export const userConfirmRegistration = (formData, resetForm, openAlert, redirectToUserProfile) => async (dispatch) => {
  try {
    dispatch(userConfirmRegistrationStart());
    await ConfirmRegistration(formData).then((res) => {
      dispatch(userConfirmRegistrationSuccess(res));
      openAlert();
      resetForm();

      setTimeout(() => dispatch(getCurrentUser(redirectToUserProfile)), 1500);
    });
  } catch (error) {
    dispatch(userConfirmRegistrationFail(getErrorDetails(error)));
  }
};
